"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postStatus = void 0;
const types_1 = require("../../types");
exports.postStatus = [
    {
        id: types_1.Common.PostStatusEnum.Any,
        name: 'Any',
    },
    {
        id: types_1.Common.PostStatusEnum.Active,
        name: 'Active',
    },
    {
        id: types_1.Common.PostStatusEnum.Pending,
        name: 'Pending',
    },
    {
        id: types_1.Common.PostStatusEnum.Delete,
        name: 'Deleted',
    },
    {
        id: types_1.Common.PostStatusEnum.Cancelled,
        name: 'Cancelled',
    },
    {
        id: types_1.Common.PostStatusEnum.Disabled,
        name: 'Disabled',
    },
];
